import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=f5b02f22&scoped=true&"
import script from "./DocumentModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b02f22",
  null
  
)

export default component.exports